// extracted by mini-css-extract-plugin
export default {"divAddFiles":"AnexosMultiplos_divAddFiles__Bsqr3","tituloFiles":"AnexosMultiplos_tituloFiles__mw-sW","item":"AnexosMultiplos_item__-tWtz"};